import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index';
import './script/navigator.js';
import FastClick from 'fastclick';
import './assets/iconfont/iconfont.css';
import './script/get-common-params';
import * as $http from './axios';
import util from './script/util';
import * as filters from './filters';
import directives from './directives';

import { setToken, setTabBarHeight } from './script/init';
import { initTheme } from './script/theme';
import components from './global-components';
//完整加載抽獎插件
import VueLuckyCanvas from '@lucky-canvas/vue';
// import * as Sentry from '@sentry/vue';
// import { BrowserTracing } from '@sentry/tracing';

import {
  Toast,
  Dialog,
  Button,
  PullRefresh,
  Tab,
  Tabs,
  ShareSheet,
  Popup,
  DropdownMenu,
  DropdownItem,
  Progress,
  Stepper,
  Field,
  Loading,
  Overlay,
  Lazyload,
  Popover,
  Checkbox,
  Cell,
  CellGroup
} from 'vant';
import 'vant/lib/index.css';
import './styles/vant.scss';
import i18n from './i18n/';
import EventBus from './script/event-bus';
import VConsole from 'vconsole';
import Com from '@/components-new/index.js';
import SvgWrapper from '@/components/SvgWrapper.vue';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import BugsnagPerformance, {
  DefaultRoutingProvider
} from '@bugsnag/browser-performance';
Toast.setDefaultOptions({
  duration: 3000
});

Vue.use(Checkbox);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(PullRefresh);
Vue.use(Tab).use(Tabs);
Vue.use(components);
Vue.use(ShareSheet);
Vue.use(Popup);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Com);
Vue.use(Progress);
Vue.use(Stepper);
Vue.use(Field);
Vue.use(Loading);
Vue.use(Overlay);
Vue.use(Lazyload);
Vue.use(Popover);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(VueLuckyCanvas);
Vue.component('SvgWrapper', SvgWrapper)

const isProduction = process.env.VUE_APP_ENV === 'production';
const bugsnagApiKey = isProduction
  ? '0b3f97fbec346d6e349be6b96256863b'
  : 'bdb5ec8b89da02129a9d6eb2173ea630';
function resolveRoute(url) {
  if (url.hash && url.hash.split('?') && url.hash.split('?')[0]) {
    return url.hash.split('?')[0];
  } else {
    return url.hash;
  }
}
// if (isProduction) {
Bugsnag.start({
  apiKey: bugsnagApiKey,
  plugins: [new BugsnagPluginVue()],
  appVersion: '1.0.0',
  redactedKeys: [
    'token', // exact match: "access_token"
    'Token', // exact match: "access_token"
    'refreshToken', // exact match: "access_token"
    /^password$/i // case-insensitive: "password", "PASSWORD", "PaSsWoRd"
  ]
});
BugsnagPerformance.start({
  apiKey: bugsnagApiKey,
  appVersion: '1.0.0',
  routingProvider: new DefaultRoutingProvider(resolveRoute)
});
const bugsnagVue = Bugsnag.getPlugin('vue');
bugsnagVue.installVueErrorHandler(Vue);
// Bugsnag.notify(new Error('Test error'))
// }

// if (process.env.VUE_APP_ENV != 'development') {
//   Sentry.init({
//     Vue,
//     dsn: !isProduction
//       ? 'https://12f9c8aca3434808902e7499acc607a5@sentry.nicee.tw/19'
//       : 'https://b14423ae66424bb0a6a468162e6f51ac@sentry.nicee.tw/18',
//     integrations: [
//       new BrowserTracing({
//         routingInstrumentation: Sentry.vueRouterInstrumentation(router, {
//           routeLabel: 'path'
//         }),
//         tracingOrigins: !isProduction
//           ? ['localhost', 'app.test.nicee.app', /^\//]
//           : ['app.nicee.app', /^\//]
//       })
//     ],
//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 1.0,
//     maxValueLength: 1000,
//     ignoreErrors: ['Non-Error promise rejection captured'],
//     enabled: false
//   });
//   Sentry.setTags({
//     nicee: 'app'
//   });
// }

Vue.config.productionTip = false;
Vue.prototype.$http = $http;
Vue.prototype.$util = util;
Vue.prototype.$loading = {
  show: () => {
    Toast.loading({
      duration: 0,
      loadingType: 'spinner'
    });
    document.body && document.body.classList.add('van-toast--unclickable');
  },
  clear: () => {
    Toast.clear();
    document.body && document.body.classList.remove('van-toast--unclickable');
  }
};

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key]);
});
function setCommparams() {
  const GET_COMMON_PARAMS = 'GET_COMMON_PARAMS';
  if (!window.sessionStorage.getItem(GET_COMMON_PARAMS)) {
    window.sessionStorage.setItem(GET_COMMON_PARAMS, 'true');
    util.nativePie('CLIENT_COMMPARAMS');
  }
}
initTheme();
setCommparams();
setToken();
setTabBarHeight();
if (util.getUrlParam('console') || window.location.port) {
  /**
   * region 地区 CN 大陆，TW台湾，US美国
   * platform 平台 1 web， 2 iOS， 3 Android
   * osVersion 手机系统版本
   * connectType 网络环境 wifi，4g，3g，2g，
   * uuid 用户id
   * deviceId 设备ID
   */
  const LOCAL_COMMON_PARAMS = {
    region: util.getUrlParam('region') ||'TW',
    version: '1.70.41',
    platform: '3',
    // mobileModel: 'iPhone8',
    mobileModel: 'Mix2s',
    connectType: 'wifi',
    deviceId: 'b79bb200-8290-4d30-9f9c-e9477d602403',
    appName: 'nicee',
    appFlag: 'nicee' // nicee waveePlay
  };
  window.localStorage.setItem(
    'STORAGE_COMMON_PARAMS',
    encodeURI(JSON.stringify(LOCAL_COMMON_PARAMS))
  );
  window.localStorage.setItem('STORAGE_VERSION', LOCAL_COMMON_PARAMS.version);
  window.localStorage.setItem('region', LOCAL_COMMON_PARAMS.region);
  window.localStorage.setItem(
    'STORAGE_VERSION_TAG',
    LOCAL_COMMON_PARAMS.appFlag
  );
}
window.sessionStorage.setItem('appLaunchTime', Date.now());
window.eventBus = new EventBus();
window.updateUserInfo = function(newToken) {
  store.dispatch('user/setToken', newToken);
  store.dispatch('user/setUser');
};
try {
  store.dispatch('app/getAvatarBorder');
} catch (e) {
  console.log('config error', e);
}

if (
  (['test', 'development'].includes(process.env.VUE_APP_ENV) &&
    !window.location.port)
) {
  // 非線上正式環境 && 非本地調試環境：啟動VConsole
  const myPlugin = new VConsole.VConsolePlugin('my_plugin', 'My Plugin');
  myPlugin.on('showConsole', function() {
    util.nativePie('MAIN_TAB_TOGGLE', { show: 0, duration: 0 });
  });
  myPlugin.on('hideConsole', function() {
    util.nativePie('MAIN_TAB_TOGGLE', { show: 1, duration: 0 });
  });
  VConsole.vconsole = new VConsole();
  VConsole.vconsole.addPlugin(myPlugin);
  // console.log(`项目启动，${Date.now()}`)
}

if (
  process.env.VUE_APP_ENV === 'test' ||
  process.env.VUE_APP_ENV === 'development'
) {
  Vue.config.devtools = true;
  Vue.config.performance = true;
}

FastClick.attach(document.body);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
